import OAuth from "../services/oauth"
import auth from "../services/auth"
import router from "../router"
import bus from "../services/bus"

export default {
  name: "login",

  data() {
    return {
      username: auth.username,
      password: "",
      loading: false,
      refreshing: false,
    }
  },

  mounted() {
    if (OAuth.shouldRefresh()) {
      this.refresh()
    }
  },

  methods: {
    async authenticate() {
      this.loading = true
      const success = await auth.login(this.username, this.password)

      this.loading = false
      this.password = ""

      if (success) {
        router.push("home")
      } else {
        bus.$emit("notification:error", "Identifiant ou mot de passe inconnu")
      }
    },

    async refresh() {
      this.refreshing = this.loading = true
      const success = await auth.refresh()
      this.refreshing = this.loading = false

      if (success) {
        router.push("home")
      }
    },

    validate() {
      // FIXME: `form` is undefined while the view is loading:
      // return this.$refs.form.validate();
      return !this.username || !this.password
    },
  },
}
